import { render, staticRenderFns } from "./TaskChildForm.vue?vue&type=template&id=606b3e70&"
import script from "./TaskChildForm.vue?vue&type=script&lang=js&"
export * from "./TaskChildForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports